import { SelectButton } from './SelectButton'
import { withSelectButton } from './withSelectButton'

export const ConnectedSelectButton = withSelectButton(SelectButton)

export { ConnectedSelectButton as SelectButton }
